// Strips HTML tags and decodes entities from legacy-migrated strings.
// Many requirement / contact fields imported from CakeCRM contain raw markup
// like `<strong><span class="reqliid">…</span> Se Requiere: …</strong>` that
// renders verbatim in V2 cards. Use this when displaying legacy-sourced text.
export function stripHtml(input: string | null | undefined): string {
  if (!input) return '';
  const withoutTags = String(input).replace(/<[^>]*>/g, ' ');
  let decoded = withoutTags;
  if (typeof document !== 'undefined') {
    const ta = document.createElement('textarea');
    ta.innerHTML = withoutTags;
    decoded = ta.value;
  }
  return decoded.replace(/\s+/g, ' ').trim();
}

// Converts a slug-style key ("casa_club_piscina") to a display label
// ("Casa Club Piscina"). Idempotent for already-humanized strings, so it's safe
// to apply unconditionally to mixed legacy/canonical amenity + service lists.
// Shared by the property detail, print, and vitrina views.
// Spanish connectors stay lowercase mid-phrase ("Cuarto de Servicio").
const LOWERCASE_CONNECTORS = new Set(['de', 'del', 'la', 'las', 'los', 'el', 'y', 'o', 'en', 'con', 'a', 'para']);

export function humanizeSlug(key: string): string {
  // Note: /\b\w/ is ASCII-only and mangles accented input ("área" → "áRea"),
  // so capitalization is done per space-split word instead.
  return String(key)
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLocaleLowerCase('es')
    .split(' ')
    .map((w, i) =>
      i > 0 && LOWERCASE_CONNECTORS.has(w)
        ? w
        : w.charAt(0).toLocaleUpperCase('es') + w.slice(1),
    )
    .join(' ');
}
